import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M4 12l1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z"
}), 'ArrowUpwardTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/ArrowUpwardTwoTone.js
// module id = 2127
// module chunks = 2